import { render, staticRenderFns } from "./MoveFromFixedConfirmationPopup.vue?vue&type=template&id=56dd7b5c&scoped=true"
import script from "./MoveFromFixedConfirmationPopup.vue?vue&type=script&lang=js"
export * from "./MoveFromFixedConfirmationPopup.vue?vue&type=script&lang=js"
import style0 from "./MoveFromFixedConfirmationPopup.vue?vue&type=style&index=0&id=56dd7b5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56dd7b5c",
  null
  
)

export default component.exports